/**
 * Transcription Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.1.21
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { TagResponse } from './tagResponse';
import { TranscriptionContentResponse } from './transcriptionContentResponse';

export interface TranscriptionResponse { 
    id?: string;
    orderId?: string;
    fileName?: string;
    fileUrl?: string;
    type?: TranscriptionResponse.TypeEnum;
    lang?: TranscriptionResponse.LangEnum;
    content?: Array<TranscriptionContentResponse>;
    tags?: Array<TagResponse>;
    createdAt?: Date;
}
export namespace TranscriptionResponse {
    export type TypeEnum = 'URL' | 'FILE' | 'RECORDING' | 'YOUTUBE';
    export const TypeEnum = {
        URL: 'URL' as TypeEnum,
        FILE: 'FILE' as TypeEnum,
        RECORDING: 'RECORDING' as TypeEnum,
        YOUTUBE: 'YOUTUBE' as TypeEnum
    };
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}